/* Tells Unbxd where the visitor came from, as segment attributes traffic_source and campaign_theme, so merchandising rules can target them.
   Read from the utm parameters on the landing URL (or the referrer), kept for the session, and added to every collection and search request to Unbxd. */
(function () {
  if (window.__mzSegments) return;
  window.__mzSegments = true;

  var KEY = 'mz_seg';

  // Google utm_campaign is the campaign id, so the theme comes from this lookup
  var GOOGLE_THEME = {
    '18590560231': 'watch', '22817899425': 'watch', '23386187415': 'watch', '23743039643': 'watch', '23289536157': 'clearance_watch',
    '22875021114': 'jewellery', '23088520770': 'jewellery', '23764947749': 'jewellery', '24327521270': 'jewellery', '24348495095': 'jewellery', '24354388270': 'jewellery', '24352424112': 'jewellery',
    '23720818999': 'brand', '23711165268': 'brand', '24343031499': 'brand', '24149360537': 'brand', '24154157017': 'brand', '24143642817': 'brand', '24149319056': 'brand', '24149360042': 'brand', '24107049298': 'brand',
    '24353988849': 'remarketing'
  };

  var q = new URLSearchParams(location.search);

  function read() {
    try { return JSON.parse(sessionStorage.getItem(KEY)) || null; } catch (e) { return null; }
  }
  function save(s) {
    try { sessionStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
  }

  function sourceFromUrl() {
    var src = (q.get('utm_source') || '').toLowerCase();
    var med = (q.get('utm_medium') || '').toLowerCase();
    if (/(^|[^a-z])sms([^a-z]|$)/.test(src + ' ' + med)) return 'sms';
    if (med === 'email' || src === 'sfmc' || src === 'email') return 'email';
    if (/^(facebook|fb|ig|instagram|meta)$/.test(src)) return 'meta';
    if (src === 'pinterest') return 'pinterest';
    if (src === 'bing' || q.has('msclkid')) return 'bing';
    if (src === 'google' || q.has('gclid') || q.has('gbraid') || q.has('wbraid')) return (med && med !== 'cpc' && med !== 'paid' && !q.has('gclid')) ? 'organic' : 'google';
    return '';
  }

  function sourceFromReferrer() {
    var ref = document.referrer;
    if (!ref) return 'direct';
    var host = '';
    try { host = new URL(ref).hostname; } catch (e) { return ''; }
    // our own pages, checkout and payment hops are not a new visit
    if (/(mazzucchellis\.com\.au|shopify\.com|shop\.app)$/.test(host)) return '';
    return 'organic';
  }

  function themeFromUrl() {
    var camp = q.get('utm_campaign') || '';
    var id = /^\d+$/.test(camp) ? camp : (q.get('gad_campaignid') || '');
    if (GOOGLE_THEME[id]) return GOOGLE_THEME[id];
    var c = camp.toLowerCase();
    if (!c) return '';
    var watch = /watch/.test(c), jewel = /jewel/.test(c), clear = /clearance/.test(c);
    if (/rmk|remarket|retarget|cart abandon/.test(c)) return 'remarketing';
    if (clear && watch) return 'clearance_watch';
    if (clear && jewel) return 'clearance_jewellery';
    if (/brand|chapter|dyo|design your own|store visit/.test(c)) return 'brand';
    if (watch) return 'watch';
    if (jewel) return 'jewellery';
    return '';
  }

  function clean(v) {
    return /^[a-z_]{1,30}$/.test(v || '') ? v : '';
  }

  function resolve() {
    // ?mzseg=meta&mztheme=watch forces a value, for testing in your own browser
    if (q.get('mzseg')) {
      var forced = { source: clean(q.get('mzseg')) || 'direct', theme: clean(q.get('mztheme')) };
      save(forced);
      return forced;
    }
    var fresh = sourceFromUrl();
    var hasClick = !!fresh;
    if (!fresh) fresh = sourceFromReferrer();
    var stored = read();
    if (fresh && (hasClick || !stored || fresh !== 'direct')) {
      var s = { source: fresh, theme: hasClick ? themeFromUrl() : '' };
      save(s);
      return s;
    }
    if (stored) return stored;
    var d = { source: 'direct', theme: '' };
    save(d);
    return d;
  }

  var state = resolve();

  function segment() {
    var parts = ['traffic_source:' + state.source];
    if (state.theme) parts.push('campaign_theme:' + state.theme);
    return parts.join(',');
  }
  window.mzSegment = { get: segment, state: state };

  // the SDK starts its first request before we can reach its options, so add the parameter on the way out
  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : input && input.url;
        if (url && /^https:\/\/search\.unbxd\.io\/[^/]+\/[^/]+\/(category|search)\?/.test(url) && !/[?&]segment=/.test(url)) {
          var next = url + '&segment=' + segment();
          input = typeof input === 'string' ? next : new Request(next, input);
        }
      } catch (e) {}
      return nativeFetch.call(this, input, init);
    };
  }
})();
